import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    property: [
       {
        "id": 37053,
        "status": "Available",
        "heading": "Melbourne's Trophy Penthouse",
        "description": "A Golden Skyline reflected in the 24 carat gold crowned skyscraper. The tallest building in the World's most livable city of Melbourne. In the heart of Southbank with endless outlooks of Melbourne's captivating skyline. An exceptional penthouse spanning an entire floor of the Eureka Tower boasts 360 degrees of floor to ceiling windows, capturing spectacular views of the ocean, mountain ranges, a humming Melbourne metropolis, golden sunrises and star studded sunsets\. ",
        "descriptionLong": "A Golden Skyline reflected in the 24 carat gold crowned skyscraper. The tallest building in the World's most livable city of Melbourne. In the heart of Southbank with endless outlooks of Melbourne's captivating skyline. An exceptional penthouse spanning an entire floor of the Eureka Tower boasts 360 degrees of floor to ceiling windows, capturing spectacular views of the ocean, mountain ranges, a humming Melbourne metropolis, golden sunrises and star studded sunsets\. A private lift lobby welcomes you in to the home of five luxurious bedrooms all with private ensuites and walk in robes. The master suite showcasing an Italian Kos spa bath with views above the clouds to the North. In the centre; two fully equipped kitchens and a 1,400 bottle temperature controlled wine cellar. Vast living, dining and entertaining spaces act as an arena to watch the city and mountains to the South. A home theatre to the East and to the West; a stunningly large executive wing with boardroom capacity, his and hers powder rooms and additional living \. The home incorporating bespoke furniture selected specifically to suit the spaces. Furniture selection and art direction by Molecule Studio, architecture and interior design by Fitt De Felice \. See Melbourne's best in sporting arenas; the MCG, Rod Laver Arena (home to the Australia Open), AAMI Stadium and the Yarra River. Arts and entertainment; the Arts Centre, Federations Square, numerous theatres, Crown Casino and Southbank Promenade, world class boutiques and dining and beautiful sandy beaches. In the distance, greater Melbourne is home to internationally recognised wineries and accommodation in the Yarra Valley to the North East and the Mornington Peninsula along the beach to the South, all of which can be reached by car or helicopter \. The attitude of 'Only the Best' pervades throughout. Exclusively Melbourne. Exclusively Level 82. The Apex of Living.",
        "address": "Level 82/7 Riverside Quay",
        "suburb": "Southbank",
        "bedrooms": 5,
        "bathrooms": 5,
        "study": null,
        "floors": null,
        "parking": 8,
        "storage_cage": null,
        "floor_area": null,
        "balcony_area": null,
        "total_area": null,
        "frontage": null,
        "land_size": null,
        "externalsize": 0,
        "homesize": 0,
        "lotsize": 0,
        "price": 25000000,
        "latitude":"-37.821334",
        "longitude":"144.964698",
        "price_show": false,
        "stamp_duty": null,
        "created_at": "2019-09-04 16:07:10",
        "updated_at": "2020-03-31 11:44:41",
        "images": [
          "/images/00822229_img_01.jpg",
          "/images/00822229_img_02.jpg",
          "/images/00822229_img_03.jpg",
          "/images/00822229_img_04.jpg",
          "/images/00822229_img_05.jpg",
          "/images/00822229_img_06.jpg",
          "/images/00822229_img_07.jpg",
          "/images/00822229_img_08.jpg",
          "/images/00822229_img_09.jpg",
          "/images/00822229_img_10.jpg",
          "/images/00822229_img_11.jpg",
          "/images/00822229_img_12.jpg",
          "/images/00822229_img_13.jpg",
          "/images/00822229_img_14.jpg",
          "/images/00822229_img_15.jpg",
        ],
        "floorplan": "/floorplan/floorplan.gif",
        "agents":[
          {
            "name": "Gerald Betts",
            "position": "Director",
            "phone": "0418 371 855",
            "email": "test@rtedgar.com",
            "image":"/agents/agent-1.jpg"
          },{
            "name": "Cristina Porto",
            "position": "Licensed Estate Agent",
            "phone": "0402 269 181",
            "email": "test@rtedgar.com",
            "image":"/agents/agent-2.jpg"
          }
        ],
        "soi": "https://s3-ap-southeast-2.amazonaws.com/documents.listonce.com.au/822229/statementofinformation-asset-87589.pdf"
      }
    ]
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
  getters,
})
